import { inject } from '@angular/core';
import { of, from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { type CanActivateFn } from '@angular/router';
import { SsoAuthService } from '../services/sso-auth.service';

export const ssoAuthGuard: CanActivateFn = (_route, state) => {
  const ssoAuthService = inject(SsoAuthService);
  const requestedUrl = state.url || '/';

  if (ssoAuthService.hasValidAccessToken()) {
    return of(true);
  }

  return from(ssoAuthService.tryLogin()).pipe(
    map(loggedIn => {
      if (loggedIn) {
        return true;
      }

      ssoAuthService.startLogin(requestedUrl);
      return false;
    }),
    catchError((error: unknown) => {
      console.error(error);
      ssoAuthService.startLogin(requestedUrl);
      return of(false);
    }),
  );
};
